import { connect } from 'react-redux'
import CommentEntry from './comment-entry'
import { getComment } from '../../../../../../stores/comments/comments.selectors'
import { format } from 'date-fns/esm'

const mapStateToProps = (state, { id }) => {
  const comment = getComment(state, id)
  return {
    date: format(comment.created_at, 'dd.MM.yyyy'),
    comment: comment.content,
    status:
      comment.status === 'approved'
        ? true
        : comment.status === 'pending'
          ? 'pending'
          : false
  }
}

export default connect(
  mapStateToProps,
  null
)(CommentEntry)
